import React from 'react';
import PropTypes from 'prop-types';
import en from 'react-intl/locale-data/en';
import fr from 'react-intl/locale-data/fr';
import es from 'react-intl/locale-data/es';
import {IntlProvider, addLocaleData} from 'react-intl';
import moment from 'moment';
import qwest from 'qwest';
import path from 'path';
import {debugComponent} from '../helpers/debug';

import * as locales from '../helpers/locale';
import {getTokenData} from '../helpers/data-helper';
import events from '../../lib/events.js';

addLocaleData([...en, ...fr, ...es]);

class IntlWrapper extends React.Component {
  static propTypes = {
    children: PropTypes.any.isRequired,
  };

  state = {
    locale: undefined,
    allMessages: {},
  };

  componentWillMount() {
    const token = getTokenData();
    const defaultLocale = token.locale;
    let locale = locales.enUS;

    if (defaultLocale) {
      locale = Object.values(locales).find(x => x.long === defaultLocale) || locale;
    }

    this.fetchCopy(locale)
      .then(messages => {
        const {allMessages} = this.state;

        allMessages[locale.long] = messages;
        this.setState({allMessages, locale});
      });
  }

  componentDidMount() {
    events.subscribe('set.language', this.changeLanguage);
  }

  fetchCopy = locale => {
    console.log('Fetching copy');
    const allMessages = this.state.allMessages;

    document.querySelector('html').lang = locale.long.substr(0, 2);

    return new Promise((resolve, reject) => {
      if (allMessages && allMessages[locale.long]) {
        resolve(allMessages[locale.long]);
        return;
      }

      qwest.get((window.canopyURL || '') + path.join('/Content/copy/languages', `${locale.long}.json?v=${window.dateStamp || 1}`), null, {
        headers: {},
        cache: true,
      })
        .then((xhr, res) => res)
        .then(messages => resolve(messages))
        .catch(err => {
          console.error(err);
          reject(err);
        });
    });
  };

  changeLanguage = newLocale => {
    let locale = locales.enUS;

    locale = Object.values(locales).find(x => x.long === newLocale) || locale;

    if (locale === this.state.locale) {
      return;
    }

    this.fetchCopy(locale)
      .then(messages => {
        const {allMessages} = this.state;

        allMessages[locale.long] = messages;

        moment.locale(locale.long);

        this.setState({
          locale,
          allMessages,
        });
      })
      .catch(err => {
        console.error('Failed to change locale.', err);
      });
  };


  render() {
    console.log('Starting render');
    const {locale, allMessages} = this.state;

    if (!locale) {
      console.log('no locale yet');
      return null;
    }

    const messages = allMessages[locale.long];

    if (!messages || !Object.keys(messages).length) {
      console.log('no messages', messages);
      return null;
    }

    console.log('Rendering for locale', locale.long, messages);

    return <IntlProvider key={locale.long}
                         locale={locale.long}
                         messages={messages}>
      {this.props.children}
    </IntlProvider>;
  }
}

export default debugComponent(IntlWrapper);
